angular.module('jv.addToReq.controller', [])
    .controller('jvaddToReqController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','$timeout','$window','$q','jvHireBroadcastSVC',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,$timeout,$window,$q,jvHireBroadcastSVC) {
            //Used to track if the user is on the candidate list page or details page 
            $scope.CandidateListPage = false;
            $scope.CandidateDetailsPage = false;
            $scope.addToReq = {
                selectedReq: {}
            };
            
            var refreshGrid = function(){
                var CandidateListUrl = jvUrls.source+'/person/applicants.html?updateFetch=true';
                $timeout(function(){
                    $window.location.href = CandidateListUrl;
                },1500);
            };
            $scope.duplicateModal = {};
            var showDuplicateModal = function(data){
                $scope.duplicateModal.duplicateItems = data.duplicateCandidates;
                $scope.duplicateModal.successCount = data.count;
                $scope.duplicateModal.duplicateCount = $rootScope.size(data.duplicateCandidates);
                $scope.duplicateModal.modalTitle = $scope.duplicateModal.duplicateCount >1 ?  i18n['DUPLICATE_CANDIDATES_ADDED_MODAL_TITLE_MULTIPLE'] : i18n['DUPLICATE_CANDIDATES_ADDED_MODAL_TITLE_SINGLE'];
                $scope.duplicateModal.tableTitle = i18n['DUPLICATE_CANDIDATES_ADDED_TABLE_TITLE'];
                $scope.showModals('duplicateCandidates');
            };
            //notifications after submit to HM
            var showNotification = function(data) {
                if(data.count === 1){
                    //list page
                    if($scope.CandidateListPage){
                        if(data.details && ($rootScope.size(data.duplicateCandidates)>0) ){
                            showDuplicateModal(data);
                            return false;
                        }
                        if(JV.Person){
                            JV.Person.Global.grid.removeLoadingState();
                            JV.Util.showMessage(JV.Person.Const["CANDIDATE_ADDED_TO_REQ"]);
                            refreshGrid();
                        }
                        $rootScope.$emit('CandidateAddedToReq', true);
                    }else{
                        //details page
                        $scope.viewApplications(true);
                        //There are some duplicate jobs, show an alert
                        if (data.duplicateJobs && data.duplicateJobs.length !== 0) {
                            var modal_body = $scope.i18n.WE_HAVE_DETECTED_THAT + ' ' + $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName + ' ' + $scope.i18n.WITH_THE_EMAIL + ' ' + $scope.appDetails.application.candidate.email + ' ' + $scope.i18n.HAS_ALREADY_BEEN_ADDED_TO_THE_REQUISITION + ' ' + data.duplicateJobs;
                            if (params.j.length != data.duplicateJobs.length) {
                                modal_body += '. ' + $scope.i18n.APPLICANT_WILL_BE_ADDED_TO_OTHER_SELECTED_REQUISITIONS;
                            }
                            $scope.$root.modal = {
                                show: true,
                                buttons: [{
                                    label: i18n.CLOSE,
                                    click: function() {
                                        $scope.flags.loading = false;
                                        $scope.$root.modal.show = false;
                                        $scope.addToReq.selectedReq = {};
                                        $scope.addToReq.selectedReqsDetail = {};
                                        $scope.getApplicationDetails(true, true);
                                    },
                                    'class': 'cancel'
                                }],
                                cancel: function() {
                                    this.show = false;
                                },
                                title: 'Duplicate Detected',
                                body: modal_body
                            };
                        } else {
                            //candidate has been added to reqs, no duplicates
                            $scope.showMsg('CANDIDATE_ADDED_TO_REQUISITION');
                            $scope.getApplicationDetails(true, true);
                            $scope.addToReq.selectedReq = {};
                            $scope.addToReq.selectedReqsDetail = {};
                        }
                        $scope.flags.loading = false;
                    }
                }else{
                    //list page
                    if(data.details && ($rootScope.size(data.duplicateCandidates)>0) ){
                        showDuplicateModal(data);
                         return false;
                    }else{
                        if(JV.Person){
                            JV.Person.Global.grid.removeLoadingState();
                            JV.Person.Const["CANDIDATES_ADDED_TO_REQ"] = data.count +' '+JV.Person.Const["CANDIDATES_ADDED_TO_REQ"];
                            JV.Util.showMessage(JV.Person.Const["CANDIDATES_ADDED_TO_REQ"]);
                            refreshGrid();
                        }
                        $rootScope.$emit('CandidateAddedToReq', true);
                    }
                }
            };
            
            jvHireBroadcastSVC.subscribe('showAddToReqModal', function(event, data) {
                $scope.applicationId = '';
                $scope.modalData = angular.extend(data);
                if(!$scope.modalData.filterByReqModal){
                    $scope.modalData.filterByReqModal = false;
                    if($scope.modalData.appIds.length === 1){
                        //single application can be selected form the list page
                        if(!$scope.appDetails && !$scope.applicationId && !$scope.params.applicationId){
                            $scope.CandidateDetailsPage = false;
                            $scope.CandidateListPage = true;
                            $scope.listType = 'singleSelect';
                        }else{
                            $scope.CandidateDetailsPage = true;
                            $scope.CandidateListPage = false;
                            $scope.listType = 'multiSelect';
                        }
                        $scope.applicationId = data.appIds[0];
                    }else{
                        $scope.CandidateDetailsPage = false;
                        $scope.CandidateListPage = true;
                        $scope.listType = 'singleSelect';
                    }
                }else{
                    $scope.listType = 'singleSelect';
                    $scope.CandidateDetailsPage = false;
                    $scope.CandidateListPage = true;
                }
                if(JV.Person && JV.Person.Global){
                    JV.Person.Global.grid.showLoadingState();
                }
                
                if($scope.CandidateListPage && !$scope.modalData.filterByReqModal) {
                    var postData = {
                            data: $scope.modalData.appIds,
                            action: 'addToReq'
                    };

                    jvCandidatesService.validateCandidateDetails(postData, function(res) {
                        if (res.status !== 200 || !res.data) {
                            $scope.flags.loading = false;
                            return;
                        }

                        if(res.data.validApplicationIds.length === 0) {
                            var actionValidation = {};
                            actionValidation.show = true;
                            actionValidation.title = i18n.ADD_TO_REQUISITION;
                            actionValidation.message = i18n.CANDIDATES_ADD_TO_REQUISITION_MSG;
                            $rootScope.$emit('actionValidation', actionValidation);
                            return;
                        }
                        $scope.modalData.validationResult = res.data;
                        $scope.modalData.appIds = $scope.modalData.validationResult.validApplicationIds;
                        var message = {};
                           message.text = i18n.CANDIDATES_ADD_TO_REQ_MSG;
                           $scope.modalData.validationResult.message = message;
                        if($scope.modalData.validationResult.unAuthorizedApplicationCount) {
                            $scope.modalData.validationResult.unAuthorizedApplicationCountLink = $scope.modalData.validationResult.unAuthorizedApplicationCount +' '+ i18n['CANDIDATES_COMMON'];
                            $scope.modalData.validationResult.unAuthorizedApplicationMsg = i18n['CANDIDATES_SKIP_MSG'];
                        }
                        $scope.showModals('addToReq');
                    });
                } else {
                    $scope.showModals('addToReq');
                }
                

            });
            var i18n = i18n || {};
            if(!$.isEmptyObject($scope.i18n)){
                i18n = angular.copy($scope.i18n);
            }

            // Modal Information
            $scope.modals = {
                addToReq: {
                    show: false
                },
                duplicateCandidates : {
                    show:false
                }
            };
            
            //Setting up add to Req modal configs
            var getmodalConfig = function(action){
                switch (action) {
                    case 'addToReq':
                    //Add to Req modal config 
                    $scope.addToReqModalConfig = {
                        resetModalOn: 'modals.addToReq.show',
                        list: {
                            config: {
                                type: $scope.listType,
                                keyName: 'selectedReqEId',
                                label: i18n['LIST_MODAL_TEXT'],
                                tooltip: {
                                    show: true,
                                    text: i18n['CANDIDATES_HIRING_MANAGER_NOTIFIED']
                                },
                                required: true,
                                errorText:i18n['MODAL_VALIDATION_TEXT'],
                                emptySearchText: i18n['FORMTEMPLATE_H_NO_RESULTS_FOUND_PLEASE_DO_ANOTHER_SEARCH'],
                                columns: [
                                    {
                                        header: i18n['REQUISITION'],
                                        show: true,
                                        key: ['title'],
                                        ellipsis: {
                                            set: true
                                        }
                                    },
                                    {
                                        header: i18n['ID'],
                                        show: true,
                                        key: ['requisitionId']
                                    },
                                    {
                                        header: i18n['STATUS'],
                                        show: true,
                                        key: ['jobState']
                                    },
                                    {
                                        header: i18n['COMPANY'],
                                        show: 'showCompany',
                                        key: ['subsidiary.name']
                                    },
                                    {
                                        header: i18n['CATEGORY'],
                                        show: true,
                                        key: ['category.name'],
                                        ellipsis: {
                                            set: true
                                        }
                                    },
                                    {
                                        header: i18n['LOCATION'],
                                        show: true,
                                        key: ['location.name'],
                                        ellipsis: {
                                            set: true
                                        },
                                        tooltipShow: 'jobLocations',
                                        tooltipTriggerLength: 'jobLocations',
                                        tooltipTriggerClass:'italic',
                                        tooltipBodyList: 'jobLocations',
                                        tooltipBodyListId: ['name']
                                    }
                                ]
                            },
                            get: $scope.listGetObject,
                            post:{
                                callBack: $scope.addToReq.postReqs,
                                button: {
                                    label: i18n['ADD'],
                                    type: 'button',
                                    classNames:['blue-btn','float-right'],
                                    id:'addToReq-btn'
                                }
                            },
                            filters: [
                                {
                                    label: i18n['STATUS'],
                                    ghostText: i18n['ALL'],
                                    width:'w175',
                                    allowClear: true,
                                    data: $scope.statusFilter,
                                    keyName: 'reqsStatusFilter',
                                    defaultTo:'{"key":"1","mine":false,"name":"'+ i18n['OPEN'] +'"}'
                                },
                                {
                                    label: i18n['CATEGORY'],
                                    ghostText: i18n['ALL'],
                                    width:'w260',
                                    allowClear: true,
                                    data: $scope.categoryFilter,
                                    keyName: 'reqsCategoryFilter',
                                    responseKey: 'filters.Categories'
                                }
                            ],
                            search : {
                                label: i18n['SEARCH'],
                                placeholder: i18n['FORMTEMPLATE_H_SEARCH_BY_REQUISITION_OR_ID'],
                                get:{
                                    url: '/jhire/action/requisitions?'
                                }
                            }
                        }
                    };
                    return $scope.addToReqModalConfig;
                }
            };

            var getAllApplications = function(){
                if(angular.isDefined($scope.allApplications) && $scope.allApplications.list){
                    return $scope.allApplications.list;
                }
                else if($scope.modalData && angular.isDefined($scope.modalData.list)){
                    return $scope.modalData.list.list;
                }
                return [];
            };
            //Function to set up form template config. Making sure this is fired after we get workflowEId back from get appdetails call 
            var setupFormTemplateConfig = function(action){
                    //FormTemplateConfig
                    if($scope.CandidateDetailsPage){
                        //details page 
                        $scope.listGetObject = {
                            url:'/jhire/action/requisitions?',
                            params:{
                                page:'0',
                                q:'',
                                maxResults:'10',
                                mine:false
                            },
                            responseKey: 'jobs',
                            filterResultsBy: {
                                list: getAllApplications(),
                                filterKey: 'EId'
                            }
                        };
                    }else{
                        //candidate list page

                        $scope.listGetObject = {
                            url:'/jhire/action/requisitions?',
                            params:{
                                page:'0',
                                q:'',
                                maxResults:'10',
                                mine:false
                            },
                            responseKey: 'jobs'
                        };
                        
                    }
                    $scope.formTemplateConfig = getmodalConfig(action);

                    //extending the formTemplateConfig object for ofccp modal and select requisition modal on candidate list page
                    if($scope.modalData.filterByReqModal){
                        $scope.formTemplateConfig.list.config.tooltip.show = false;
                        $scope.formTemplateConfig.list.config.label = typeof properties !== 'undefined' && properties.trackSearch ? i18n['OFCCP_LIST_MODAL_TEXT'] : "";
                        $scope.formTemplateConfig.list.post.button.label = i18n['SELECT'];
                    }
                    
            };

            //used to fetch the requition filter values
            var fetchFilters = function(){
                var deferred = $q.defer();
                jvCandidatesService.getRequistionFilters(null,function(response){
                    if(response.status === 200 && response.data){
                        deferred.resolve(response.data);
                        $scope.categoryFilter = response.data.filters.Categories;
                        $scope.statusFilter = response.data.statusFilter.optionValues;
                        if ($scope.modalData.filterByReqModal) {
                            $scope.statusFilter = response.data.allStatusFilter.optionValues;
                        }
                        angular.forEach($scope.statusFilter,function(value,key){
                            value.key = JSON.stringify(value.key);
                        });
                    }
                });
                return deferred.promise;
            };

            //Used to show the move modal
            $scope.showModals = function(modal){
                fetchFilters().then(function(response){
                    if(response){
                        setupFormTemplateConfig(modal);
                        TemplateLoader.load(modal).then(function(){
                            $scope.modals[modal].show = true;
                            if(JV.Person && JV.Person.Global){
                                JV.Person.Global.grid.removeLoadingState();
                            }
                        });
                    }
                });
            };

            $scope.hideModalsAndRefresh = function(){
                $scope.hideModals();
                $rootScope.$emit('refreshCandidateSearhGrid', true);
            };
            
            //Used to hide all the modals on the page
            $scope.hideModals = function(){
                angular.forEach($scope.modals, function(val, key) {
                     $scope.modals[key].show = false;
                });
                if($scope.CandidateListPage && JV.Person && JV.Person.resetValues){
                    JV.Person.resetValues();
                }
                
            };

            //status filter option
            var statusFilter = [
                    {key:'1009',value:'Active'},
                    {key:'1009',value:'My Active','mine':true},
                    {key:'1',value:'My Open', mine: true},
                    {key:'1',value:'Open'}
            ];

            $scope.templates = TemplateLoader.register({
                addToReq: '/jhire/modules/candidates/modals/addToReq.html',
                duplicateCandidates: '/jhire/modules/candidates/modals/duplicateCandidates.html'
            });

            var removeLoadingState = function(){
                if($scope.CandidateListPage){
                    JV.Person.Global.grid.removeLoadingState();
                }else{
                   $scope.flags.loading = false;
                }
            };

            $scope.sendModalData = function(modalData){
                if(modalData  && modalData.selectedReqEId){
                    var data = {
                        reqEId : modalData.selectedReqEId,
                        reqName : ''
                    };
                    var selectedReqEId = modalData.selectedReqEId;
                    for(var i=0; i < modalData.allItems.length; i++){
                         if(selectedReqEId === modalData.allItems[i].EId){
                            data.reqName = modalData.allItems[i].title;
                            if (modalData.allItems[i].location) {
                                data.primaryLocation = modalData.allItems[i].location.name;
                            }
                            data.secondaryLocations = modalData.allItems[i].jobLocations || [];
                            data.reqId = modalData.allItems[i].requisitionId;
                            if (modalData.allItems[i].category) {
                                data.category = modalData.allItems[i].category.name;
                            }
                            break;
                        }
                    }
                    $rootScope.$broadcast('AddReqModalDataSent', data);
                }
            };

            $scope.addToReq.postReqs = function(modalData) {
                    $scope.hideModals();
                    //OFCCP Add Req Modal triggered
                    if($scope.modalData.filterByReqModal){
                        $scope.sendModalData(modalData);
                        return;
                    }

                    var data = {};
                    if(angular.isObject(modalData["selectedReqEId"])){
                        //candidate details page
                        var jobList = [];
                        angular.forEach(modalData["selectedReqEId"],function(key,reqEId){
                            jobList.push(reqEId);
                        });
                        data.jobIds = jobList;
                        data.appIds = [$scope.applicationId];
                    }else{
                        data.jobIds = [modalData["selectedReqEId"]];
                        if(JV.Person){
                            data.appIds = JV.Person.getSelectedAppIds();
                        }else{
                            data.appIds = $scope.modalData.appIds;
                        }
                        
                    }
                    
                    if($scope.CandidateListPage && JV.Person){
                        JV.Person.Global.grid.showLoadingState();
                    }
                    $scope.flags.loading = true;
                    jvCandidatesService.addCandidate(data,function(response){
                        $scope.flags.loading = false;
                        if(response.status === 200 && response.data){
                            showNotification(response.data);
                        }else{
                            //fail
                            removeLoadingState();
                        }
                    });
                
            };
        }
]);